import React from 'react';
import PropTypes from 'prop-types';

import { Stack, Grid, ModalLauncher } from '@metarouter-private/mr-mui';

import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';

import CreatePipelineModal from 'app/pipelines/modals/CreatePipelineModal';
import PipelineSearchBar from './PipelineSearchBar';
import BulkDeployButton from './BulkDeployButton';
import UpdatePlaybooksButton from './UpdatePlaybooksButton';
import NewPipelineButton from './NewPipelineButton';
import PipelinesClusterMultiSelect from './PipelinesClusterMultiSelect';
import PipelineTagMultiSelect from './PipelineTagMultiSelect';
import IntegrationSelect from './IntegrationSelect/IntegrationSelect';
import IntegrationSelectTooltip from './IntegrationSelectTooltip';
import { PipelineBulkActionsMenu } from '@ion/ion-experimental';

export default function PipelinesTableTitle({ onShowBulkPlaybookUpdate }) {
  const { bulkStageAndDeployRebuildEnabled, pipelinesBulkActionsAlphaEnabled, pipelineTagsMvpEnabled } =
    useFeatureEnabled(
      FEATURE_FLAGS.bulkStageAndDeployRebuild,
      FEATURE_FLAGS.pipelinesBulkActionsAlpha,
      FEATURE_FLAGS.pipelineTagsMvp
    );

  return (
    <Stack direction="column" spacing={2}>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={3}>
          <PipelinesClusterMultiSelect />
        </Grid>

        {pipelineTagsMvpEnabled && (
          <Grid item xs={3}>
            <PipelineTagMultiSelect />
          </Grid>
        )}

        <Grid item flexGrow={1}>
          <PipelineSearchBar />
        </Grid>
      </Grid>

      <Grid container spacing={1} alignItems="center">
        <Grid item flexGrow={1}>
          <Stack direction="row" alignItems="start" spacing={1}>
            <IntegrationSelect />
            <IntegrationSelectTooltip />
          </Stack>
        </Grid>

        <Grid item flexShrink={0}>
          {bulkStageAndDeployRebuildEnabled && <BulkDeployButton />}
        </Grid>

        <Grid item flexShrink={0}>
          {bulkStageAndDeployRebuildEnabled && (
            <UpdatePlaybooksButton onShowBulkPlaybookUpdate={onShowBulkPlaybookUpdate} />
          )}
        </Grid>

        <Grid item flexShrink={0}>
          <ModalLauncher Launcher={NewPipelineButton} Modal={CreatePipelineModal} />
        </Grid>

        <Grid item flexShrink={0}>
          {pipelinesBulkActionsAlphaEnabled && <PipelineBulkActionsMenu />}
        </Grid>
      </Grid>
    </Stack>
  );
}

PipelinesTableTitle.propTypes = {
  onShowBulkPlaybookUpdate: PropTypes.func.isRequired,
};
